import Box from "@mui/material/Box";
import React from "react";

export default function PageTopGradient() {
  return (
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "670px",
        background:
          "linear-gradient(178.04deg, rgba(35, 101, 255, 0.1) 1.47%, rgba(255, 255, 255, 0) 98.17%)",
        pointerEvents: "none",
        zIndex: 0,
      }}
    />
  );
}
